import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   CommentRepliesResponse,
   CommentRepliesOptions,
   getCommentReplies as getCommentRepliesFromMonolith,
} from '~/monolith-api/guides';

const getCommentRepliesSchema = z.object({
   commentid: z.number(),
   limit: z.number().optional(),
   offset: z.number().optional(),
});

export async function getCommentReplies(
   commentid: number,
   { limit, offset, ...common }: CommentRepliesOptions = {}
) {
   return await getCommentRepliesFromMonolith(commentid, {
      ...common,
      limit,
      offset,
   });
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { commentid, limit, offset } = getCommentRepliesSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getCommentReplies(commentid, {
         apiClient: monolithClient,
         limit: limit,
         offset: offset,
      });
      res.status(200).json(result);
   },
});

export const getCommentRepliesFromClient = (
   commentid: number,
   { limit, offset }: CommentRepliesOptions = {}
): Promise<CommentRepliesResponse> => {
   return bff()
      .post('/guides/getCommentReplies', { commentid, limit, offset })
      .then(response => response.data);
};
